import React, { useState, useEffect, createRef } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IKebabProps, IKebabItem } from '../../interfaces/Kebab.interface';

// STYLES
import { ContainerKebab, ContainerIcon, Options, ContentKebab, ItemKebab } from './styles';

const Kebab: React.FC<IKebabProps> = ({ side, items, big, gray }: IKebabProps) => {
  const container = createRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
  });

  const handleClickOutside = (event: Event) => {
    if (container.current && !container.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  const handleKebabisOpening = () => {
    setIsOpen(!isOpen);
  };

  const handleButtonClickClose = () => {
    setIsOpen(false);
  };

  return (
    <ContainerKebab ref={container}>
      <ContainerIcon big={big} gray={gray} isOpen={isOpen} onClick={handleKebabisOpening}>
        <Icon type={Icons.KEBAB} />
      </ContainerIcon>
      {isOpen && (
        <Options side={side} big={big} items={items} onClick={handleButtonClickClose}>
          {items && (
            <ContentKebab>
              {items.map((item: IKebabItem, idx) => {
                return (
                  <ItemKebab id={item.id} onClick={item.onClick} key={idx} className={item.type}>
                    {item.text} {item.icon}
                  </ItemKebab>
                );
              })}
            </ContentKebab>
          )}
        </Options>
      )}
    </ContainerKebab>
  );
};

export default Kebab;
